/**
 * Minimal class-name joiner. Deliberately dependency-free (no clsx/cva) —
 * this is the only utility the UI primitives need, and a 12-line function
 * beats another package in the tree.
 */
export type ClassValue = string | number | null | undefined | false | ClassValue[];

export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const v of values) {
    if (!v && v !== 0) continue;
    if (Array.isArray(v)) {
      const nested = cn(...v);
      if (nested) out.push(nested);
    } else {
      out.push(String(v));
    }
  }
  return out.join(' ');
}
